import { ContactSupportButton } from '../../components/button/ContactSupportButton';
import { createErrorBoundary } from '../../components/error/CreateErrorBoundary';

export const AmsAuthErrorBoundary = createErrorBoundary({
  name: 'AmsAuthErrorBoundary',
  logMessage: 'AMS Dashboard error',
  titleKey: 'amsAuthErrorTitle',
  bodyKey: 'amsAuthErrorBody',
  secondaryAction: <ContactSupportButton />,
  logContext: { page: 'reporting' },
});
